import { ProductDtoToEntity } from "src/app/features/Product/services/mappers/ProductDtoToEntity";
import type { ProductDto } from "src/app/features/Product/types/ProductDto";
import type { ProductEntity } from "src/app/features/Product/types/ProductEntity";
import type { ResourcePageDto } from "../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../core/types/fe/entities/ResourcePageEntity";

export const ProductTableDtoMapper = (input: Readonly<ResourcePageDto<ProductDto>>): ResourcePageEntity<ProductEntity> => {
    return {
        list: input.list ? input.list.map(ProductDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
